import * as React from "react";
import { Chip } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";

/** The red of the Google Maps pin. */
export const GOOGLE_MAPS_RED = "#EA4335";

/** Google Maps directions to an address. The Directions chip and address links all open this same page. */
export const directionsUrl = (address) => `https://www.google.com/maps/dir//${encodeURIComponent(address)}`;

export default function DirectionsChip({ address }) {
  if (!address) return null;
  return (
    <Chip
      icon={<PlaceIcon />}
      label="Directions"
      size="small"
      component="a"
      href={directionsUrl(address)}
      target="_blank"
      rel="noopener noreferrer"
      clickable
      // Neutral outline and the normal text color (black in light mode, white in dark), underlined like a link, with
      // the pin in Google Maps red.
      color="default"
      variant="outlined"
      sx={{
        "& .MuiChip-label": { textDecoration: "underline" },
        "& .MuiChip-icon": { color: GOOGLE_MAPS_RED },
      }}
    />
  );
}
